










































































































































































































































































import http from "@/axios/http-common";
import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";
import ResepInputGuided from "../modal/CardResepInputGuided.vue";
import CardListTemplateResep from "@/components/modal/CardListTemplateResep.vue";
import CardResepTerstrukturInput from "@/components/modal/CardResepTerstrukturInput.vue";
import ResepTerstrukturSvc, {
  KonfigResepTerstruktur
} from "@/services/ResepTerstruktur";
import { labelTempelan, tempelanDariResep } from "@/utils/tempelResep";
import {
  BarisResepTerstruktur,
  DEPO_HD,
  RacikanTerstruktur,
  barisKePayload,
  racikanKePayload
} from "@/utils/resepTerstruktur";
import { isEmpty, join, values, mapValues } from "lodash";
import { appModule } from "@/store/modules/app";
import { AxiosError } from "node_modules/axios";
import { userModule } from "@/store/modules/user";
import { storeSoap } from "@/store/modules/soap";
import { storePasien } from "@/store/modules/pasien";
import { storeCopy } from "@/store/modules/copy";
import { Textcomplete } from "@textcomplete/core";
import { TextareaEditor } from "@textcomplete/textarea";
import ResepTextComplete from "@/utility/ResepTextComplete";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import { storeResume } from "@/store/modules/resume";

interface Resep {
  id: number;
  text: string;
  depo_id: string;
  bb: number;
  alergi: string;
  diagnosis: string;
  dr_id: number;
  unit_id: string;
  pasien_cm: number;
  register_id: number;
  status: number;
  lock_version?: number;
  items?: any[];
  resep_racikan?: any[];
}

let resepTextSeq = 0;

@Component({
  components: {
    ResepInputGuided,
    CardListTemplateResep,
    CardResepTerstrukturInput
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputResep extends Vue {
  input = {
    text: "",
    depo_id: "",
    bb: null,
    alergi: "",
    diagnosis: "",
    doctor_note: ""
  };
  baseData = {
    dr_id: null,
    unit_id: null,
    pasien_cm: null,
    register_id: null
  };
  text = "";
  withSend = true;
  depoList = [
    {
      text: "Apotik Ralan Atas",
      value: "22"
    },
    {
      text: "Apotik Ralan Bawah",
      value: "02"
    },
    {
      text: "Apotik IGD",
      value: "05"
    },
    {
      text: "Apotik Ranap",
      value: "03"
    },
    {
      text: "Apotik HD",
      value: "08"
    }
  ];
  sending = false;
  saving = false;
  showInputGuided = false;
  showTemplateModal = false;
  showTerstruktur = false;
  pakaiTeks = false;
  konfigUnit: KonfigResepTerstruktur = { unit_id: "", aktif: false, wajib: false };
  tempelan: {
    items: any[];
    racikan: any[];
    label: string;
    teks: string | null;
  } | null = null;
  statusTemplateModal = false;
  templateMode = "list";
  rules = {
    required: value => !!value || "Kolom ini harus diisi"
  };
  textcomplete: Textcomplete;
  editor: TextareaEditor;
  resepText: HTMLTextAreaElement;
  // showTextComplete = true;

  resepTextId = `resepText-${++resepTextSeq}`;

  @Prop() resep: Resep;

  @Prop() register: number;

  @Prop() rm: number;

  @Ref() readonly inputText!: HTMLTextAreaElement;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get isSent() {
    return this.resep.status >= 1;
  }

  get isEditable() {
    return isEmpty(this.resep) || this.resep.status < 2;
  }

  get disableSendBtn() {
    return (
      this.sending || isEmpty(this.resep) || this.resep.status > 1 || this.readOnly
    );
  }

  get dataSend() {
    return {
      dr_id: userModule.user.id,
      unit_id: userModule.user.unit_id,
      register_id: this.register,
      pasien_cm: this.rm,
      ...this.input
    };
  }

  get isSoapExist() {
    return this.userSoap.length;
  }

  get userSoap() {
    return storeSoap.soapAll.filter(soap => {
      return soap.user.id == userModule.user.id;
    });
  }

  get userSoapRanap() {
    return SoapRanapStore.soap.filter(soap => {
      return soap.user_id == userModule.user.id;
    });
  }

  get editing() {
    return resepStore.inputResepMode;
  }

  get isUnitRalan() {
    return userModule.user.unit_id > "01" && userModule.user.unit_id < "30";
  }

  get pasienAlergi() {
    return storePasien.identitasPasien?.alergi;
  }

  get itemAktif(): any[] {
    const items = Array.isArray(this.resep?.items) ? this.resep.items : [];
    return items.filter(item => !item.stopped_at && !item.r);
  }

  get adaRacikan(): boolean {
    return Array.isArray(this.resep?.resep_racikan) && this.resep.resep_racikan.length > 0;
  }

  get resepTerstruktur(): boolean {
    return this.itemAktif.length > 0 || this.adaRacikan;
  }

  get modeTerstruktur(): boolean {
    return this.konfigUnit.aktif || this.resepTerstruktur;
  }

  get teksDiizinkan(): boolean {
    return !this.resepTerstruktur && !this.konfigUnit.wajib;
  }

  get teksHdDiizinkan(): boolean {
    return !this.resepTerstruktur && this.konfigUnit.wajib;
  }

  get itemsTerstruktur(): any[] {
    return this.tempelan ? this.tempelan.items : this.itemAktif;
  }

  get racikanTerstruktur(): any[] {
    if (this.tempelan) {
      return this.tempelan.racikan;
    }
    return this.adaRacikan ? this.resep.resep_racikan : [];
  }

  get unitLogin(): string {
    return userModule.user?.unit_id;
  }

  testRef() {
    console.log(this.inputText);
  }

  mounted() {
    const konfig = this.muatKonfigUnit();

    this.resepText = this.resolveResepTextArea();

    appModule.setLoading(false);

    resepStore.hideInputResep();

    konfig.finally(() => {
      this.changeStatusPasteInstant(this.statusPasteInstant);
    });

    this.syncTextComplete(this.showTextComplete);
  }

  beforeDestroy() {
    ResepTextComplete.destroy(this.resepText);
  }

  resolveResepTextArea(): HTMLTextAreaElement {
    const byRef = (this.$refs.inputText as unknown) as {
      $refs?: { input?: HTMLTextAreaElement };
    };

    if (byRef && byRef.$refs && byRef.$refs.input) {
      return byRef.$refs.input;
    }

    const root = this.$el as Element;

    if (!root || typeof root.querySelector !== "function") {
      return null;
    }

    return (root.querySelector(`#${this.resepTextId}`) ||
      root.querySelector("textarea[name=resep_text]")) as HTMLTextAreaElement;
  }

  @Watch("showTextComplete")
  syncTextComplete(show: boolean) {
    ResepTextComplete.destroy(this.resepText);

    if (!show) {
      return;
    }

    if (!this.resepText || !document.contains(this.resepText)) {
      this.resepText = this.resolveResepTextArea();
    }

    ResepTextComplete.init(this.resepText, this.input.depo_id);

    ResepTextComplete.on(this.resepText, "select", evt => {
      const data = evt.detail.searchResult.data;

      if (!data.stockQty) {
        const q = confirm(
          `Obat/Alkes yang Anda pilih (${data.nama}) tidak ada stok tersedia. Tetap lanjut?`
        );

        if (!q) {
          evt.preventDefault();
        }
      }
    });
  }

  preInputValidation() {
    if (this.isUnitRalan && !this.isSoapExist) {
      appModule.sendErrorAlert(
        "Mohon isi Catatan SOAP terlebih dahulu sebelum membuat resep"
      );

      return false;
    }

    if (this.isSent) {
      appModule.sendErrorAlert(
        "Tidak bisa mengubah resep yang telah terkirim. Untuk mengubah klik tombol merah 'Batal Kirim' terlebih dahulu."
      );

      return false;
    }

    if (!this.isEditable) {
      appModule.sendErrorAlert(
        "Tidak bisa mengubah resep karena telah diproses Instalasi Farmasi"
      );

      return false;
    }

    return true;
  }

  isEmpty(val: object) {
    return isEmpty(val);
  }

  showInputTemplate() {
    this.templateMode = "input";
    this.$nextTick(function() {
      this.showTemplateModal = true;
    });
  }

  showListTemplate() {
    this.templateMode = "list";
    this.$nextTick(function() {
      this.showTemplateModal = true;
    });
  }

  assignResepText(text: string) {
    this.input.text = this.input.text.concat(`\r\n${text}`).trim();
    this.showTemplateModal = false;
  }

  clearInputField(): void {
    this.templateMode = "list";
    this.tempelan = null;
    for (const key in this.input) {
      this.input[key] = "";
    }
  }

  inputGuideOnClose() {
    this.showInputGuided = false;
    this.$nextTick(function() {
      this.inputText.focus();
    });
  }

  @Watch("unitLogin")
  async muatKonfigUnit() {
    const unitId = this.unitLogin;
    const konfig = await ResepTerstrukturSvc.konfigUnit(unitId);
    if (unitId === this.unitLogin) {
      this.konfigUnit = konfig;
    }
  }

  editInput(opts = { focus: true }) {
    if (this.modeTerstruktur) {
      this.bukaTerstruktur();
      return;
    }
    this.editTeks(opts);
  }

  editTeks(opts = { focus: true }) {
    if (this.preInputValidation()) {
      this.pakaiTeks = true;
      resepStore.showInputResep();
      this.$nextTick(() => {
        if (opts.focus) {
          this.inputText.focus();
        }
      });
    }
  }

  editTeksHd() {
    this.editTeks({ focus: true });
    this.$nextTick(() => {
      this.input.depo_id = DEPO_HD;
    });
  }

  editWithInputGuided() {
    if (this.preInputValidation()) {
      this.editTeks({ focus: false });
      this.showInputGuided = true;
    }
  }

  bukaTerstruktur() {
    if (!this.preInputValidation()) return;
    resepStore.showInputResep();
    this.$nextTick(() => {
      this.showTerstruktur = true;
    });
  }

  tutupTerstruktur() {
    this.showTerstruktur = false;
    this.tempelan = null;
    this.doneInput();
  }

  simpanTerstruktur(hasil: {
    items: BarisResepTerstruktur[];
    racikan: RacikanTerstruktur[];
    kirim: boolean;
  }) {
    if (this.readOnly || this.saving) return;

    const editing = !!(this.resep && this.resep.id);
    const racikan = hasil.racikan.map(racikanKePayload);
    const payload: any = {
      ...this.dataSend,
      text: "",
      kategori: "o",
      items: [
        ...hasil.items.map(barisKePayload),
        ...racikan.flatMap(r => r.komponen)
      ],
      racikan: racikan.map(r => r.header)
    };

    if (editing && this.resep.lock_version !== undefined) {
      payload.lock_version = this.resep.lock_version;
    }

    this.saving = true;

    const endPoint = editing
      ? http.putData(`/resep-obat-text/${this.resep.id}`, payload)
      : http.postData("/resep-obat-text", payload);

    endPoint
      .then(response => {
        this.showTerstruktur = false;
        this.tempelan = null;
        this.$emit("set-active-resep", response.data.data);
        this.doneInput();

        if (hasil.kirim) {
          this.send(response.data.data.id);
        }

        this.muatUlangDaftar(response.data.data.register_id);

        appModule.sendSuccessNotice(
          editing ? "Berhasil mengubah resep!" : "Berhasil membuat resep!"
        );
        appModule.closeNoticeWithDelay();
      })
      .catch(err => {
        if (err?.response?.status === 409) {
          this.showTerstruktur = false;
          this.tempelan = null;
          this.doneInput();
          this.muatUlangResepAktif();
          return;
        }
        this.showErrorAlert(err);
      })
      .then(() => {
        this.saving = false;
      });
  }

  muatUlangResepAktif() {
    if (!this.resep || !this.resep.id) return;
    http.getData(`/resep-obat-text/${this.resep.id}`).then(response => {
      this.$emit("set-active-resep", response.data.data);
    });
    this.muatUlangDaftar(this.register);
  }

  muatUlangDaftar(registerId) {
    http.getData(`/register/${registerId}/resep-obat-text`).then(refresh => {
      resepStore.setResep(refresh.data.data);
    });
  }

  save() {
    if (this.readOnly) return;
    if (this.resep && this.resep.id && this.resepTerstruktur) {
      appModule.sendErrorAlert(
        "Resep ini berisi obat terstruktur. Ubah lewat tombol Input Terstruktur agar daftar obat tidak terhapus."
      );
      return false;
    }
    if (!this.input.depo_id || !this.input.text || !this.input.diagnosis) {
      appModule.sendErrorAlert(
        "Tidak dapat menyimpan bila kolom Depo, Text Resep, dan Diagnosa belum diisi"
      );

      return false;
    }

    if (!this.saving) {
      this.saving = true;

      const endPoint = this.resep.id
        ? http.putData(`/resep-obat-text/${this.resep.id}`, this.dataSend)
        : http.postData("/resep-obat-text", this.dataSend);

      endPoint
        .then(response => {
          this.$emit("set-active-resep", response.data.data);

          this.doneInput();

          // send resep
          if (this.withSend) {
            this.send(response.data.data.id);
          }

          http
            .getData(
              `/register/${response.data.data.register_id}/resep-obat-text`
            )
            .then(response => {
              resepStore.setResep(response.data.data);
            });

          const notice = this.resep.id
            ? "Berhasil mengubah resep!"
            : "Berhasil membuat resep!";
          appModule.sendSuccessNotice(notice);
          appModule.closeNoticeWithDelay();
        })
        .catch(err => {
          this.showErrorAlert(err);
        })
        .then(() => {
          this.saving = false;
        });
    }
  }

  showErrorAlert(err: AxiosError) {
    const dt = err.response;
    let message = "";
    if (!dt) {
      return;
    }
    if (dt["status"] == 422) {
      message = join(
        values(
          mapValues(err.response.data.errors, function(val) {
            return join(val, "; ");
          })
        ),
        "; "
      );
    } else {
      message = `ERR ${err.response.status}: ${err.response.data.message}`;
    }

    appModule.sendErrorAlert(message);
  }

  doneInput() {
    this.pakaiTeks = false;
    resepStore.hideInputResep();
    this.clearInputField();
  }

  send(id) {
    if (this.readOnly) return;
    if (!this.sending) {
      this.sending = true;

      http
        .putData(`/resep-obat-text/${id}/send`, null)
        .then(response => {
          // this.resep.status = 1;
          this.$emit("set-active-resep", response.data.data);
          this.$emit("update-resep-list");

          appModule.sendSuccessNotice("Berhasil mengirim resep ke farmasi");
          appModule.closeNoticeWithDelay();
        })
        .catch(err => {
          this.showErrorAlert(err);
        })
        .then(() => {
          this.sending = false;
        });
    }
  }

  undoSend(id) {
    if (this.readOnly) return;
    if (!this.sending) {
      this.sending = true;

      http
        .putData(`/resep-obat-text/${id}/undo-send`, null)
        .then(response => {
          // this.resep.status = 0;
          this.$emit("set-active-resep", response.data.data);
          this.$emit("update-resep-list");
        })
        .catch(err => {
          this.showErrorAlert(err);
        })
        .then(() => {
          this.sending = false;
        });
    }
  }

  @Watch("showTemplateModal")
  changedShowTemplate(val) {
    this.$nextTick(() => {
      this.statusTemplateModal = val;
    });
  }

  @Watch("showInputGuided")
  changedShowInputGuided(show) {
    if (show) {
      resepStore.showInputResep();
    }
  }

  get asesmenGadarMedis() {
    return AsesmenGadarMedisStore;
  }

  get dxResume() {
    return storeResume.resume && storeResume.resume.length
      ? storeResume.resume[0]?.diagnosis
      : [];
  }

  @Watch("editing")
  changedEditing(editing: boolean) {
    console.log("change editing", editing);
    if (!editing) {
      this.clearInputField();
    } else {
      if (this.modeTerstruktur && !this.pakaiTeks && !this.showTerstruktur) {
        this.$nextTick(() => {
          this.showTerstruktur = true;
        });
      }
      if (Object.keys(this.resep).length) {
        for (const key in this.input) {
          this.input[key] = this.resep[key];
        }
      } else {
        if (userModule.user.unit_id == "01") {
          this.input.diagnosis =
            this.asesmenGadarMedis.inputFields?.diagnosis_kerja || "";
          this.input.alergi = storePasien.identitasPasien.alergi;
          this.input.depo_id = "05";
        } else if (userModule.user.unit_id < "50") {
          const dxSoap = this.userSoap[0]?.a ? String(this.userSoap[0].a) : "",
            dxRsm = this.dxResume
              .map(it => `${it.kode} - ${it.nama}`)
              .join("\r\n");

          this.input.diagnosis = dxRsm ? dxRsm : dxSoap;
          this.input.alergi = storePasien.identitasPasien.alergi;
          this.input.depo_id = userModule.user.zona == "3" ? "22" : "02";
        } else if (userModule.user.unit_id >= "50") {
          this.input.diagnosis = this.userSoapRanap[0]?.assesment
            ? String(this.userSoapRanap[0].assesment)
            : "";
          this.input.alergi = storePasien.identitasPasien.alergi;
          this.input.depo_id = "03";
        }
      }

      if (isEmpty(userModule.preference?.inputResep)) {
        this.showTextComplete = true;
      }
    }
  }

  @Watch("resep", { deep: true })
  changedResep(val: Resep) {
    console.log("changed resep", val);
    this.text = val?.text;

    if (this.editing && this.pakaiTeks && this.resepTerstruktur) {
      this.pakaiTeks = false;
      for (const key in this.input) {
        this.input[key] = this.resep[key];
      }
      this.showTerstruktur = true;
    }
  }

  // @Watch("textObat")
  // changedTextObat(val: string) {
  //   this.input.text = this.input.text.concat(`\r\n${val}`).trim();
  // }

  @Watch("input.depo_id", { deep: true })
  changedInputDepoId(val: string) {
    ResepTextComplete.setDepo(this.resepText, val);

    resepStore.setDepoId(val);
  }

  inputTextClickOutside() {
    ResepTextComplete.hide(this.resepText);
  }

  closeTemplateModal() {
    this.showTemplateModal = false;
    this.templateMode = null;
  }

  // get textObat() {
  //   return resepStore.inputText;
  // }

  get statusPaste() {
    return storeCopy.copyResep;
  }

  get statusPasteInstant() {
    return storeCopy.copyResepInstant;
  }

  get paste() {
    return storeCopy.pasteresep;
  }

  tempelResep(val) {
    if (this.readOnly) {
      appModule.sendErrorAlert(
        "Pemeriksaan ini sudah terkunci — resep tidak bisa ditempel."
      );
      return;
    }

    const isi = tempelanDariResep(val);
    const adaIsi = isi.items.length > 0 || isi.racikan.length > 0;

    if (adaIsi || (this.modeTerstruktur && !this.editing)) {
      if (!isEmpty(this.resep) || this.editing) {
        appModule.sendErrorAlert(
          "Tidak bisa tempel Resep karena sudah ada Resep yg anda buat"
        );
        return;
      }

      if (!this.preInputValidation()) {
        return;
      }

      this.tempelan = {
        ...isi,
        label: labelTempelan(val),
        teks: adaIsi ? null : val.text || null
      };
      storeCopy.clear_copy_resep();
      resepStore.showInputResep();
      this.$nextTick(() => {
        this.showTerstruktur = true;
      });
      return;
    }

    if (this.editing == true) {
      if (this.input.text == "") {
        this.input.text = val.text;
        storeCopy.clear_copy_resep();
        // console.log("")
      } else {
        //
        appModule.sendErrorAlert(
          "Tidak bisa tempel Resep karena sudah ada Resep yg anda buat"
        );
      }
    } else {
      if (!isEmpty(this.resep)) {
        appModule.sendErrorAlert(
          "Tidak bisa tempel Resep karena sudah ada Resep yg anda buat"
        );
      } else {
        this.editInput();

        this.$nextTick(() => {
          this.input.text = val.text;
          storeCopy.clear_copy_resep();
        });
      }
    }
  }

  appendResepText(text) {
    this.input.text = this.input.text.concat(`\r\n${text}`).trim();
  }

  get showTextComplete() {
    return userModule.preference?.inputResep?.showAutocompleteFreeText ?? false;
  }

  set showTextComplete(val) {
    this.syncTextComplete(val);

    userModule.savePreference({
      inputResep: {
        showAutocompleteFreeText: val
      }
    });
  }

  @Watch("statusPasteInstant")
  changeStatusPasteInstant(val) {
    if (val) {
      this.tempelResep(this.paste);
    }
  }
}
